const en = {
  "lang.switch": "Choose language",
  "gallery.title": "Gallery",
  "gallery.enlarge": "Enlarge {alt}",
  "gallery.close": "Close gallery",
  "gallery.prev": "Previous image",
  "gallery.next": "Next image",
  "gallery.left.alt": "NYX Hotel Hamburg left view",
  "gallery.middle.alt": "NYX Hotel Hamburg centre view",
  "gallery.right.alt": "NYX Hotel Hamburg right view",
  "gallery.a.alt": "Dr. Hoffmann massage at NYX Hotel Hamburg",
  "gallery.b.alt": "In-room hotel massage at NYX Hotel Hamburg",
  "gallery.c.alt": "Recovery session at NYX Hotel Hamburg",
  "page.title": "Choose your {em}massage{/em}",
  "page.intro":
    "Book your massage directly from the hotel tablet.",
  "page.introHighlight": "We come to you!",
  "page.introHours": "Appointments are available daily between 07:00 and 20:00, with Thursday appointments available from 20:00 to 22:00.",
  "testimonials.kicker": "Voices from the NYX",
  "testimonials.title": "Booked in moments. Noticeably lighter.",
  "testimonials.verified": "Verified booking",
  "testimonials.service.wakeup": "Wake-Up Massage",
  "testimonials.service.classic": "Classic Massage",
  "testimonials.0.name": "Marie K.",
  "testimonials.0.quote":
    "Five minutes that felt like a real reset. Perfect before an evening appointment.",
  "testimonials.1.name": "Jonas R.",
  "testimonials.1.quote":
    "Booked right at the hotel and clear-headed again shortly after. Exactly right after arrival.",
  "testimonials.2.name": "Claudia M.",
  "testimonials.2.quote":
    "The Classic massage was calm, precise and soothing. My neck and shoulders felt free afterwards.",
  "testimonials.3.name": "Nina S.",
  "testimonials.3.quote":
    "I just wanted a quick boost of energy. The Wake-Up massage delivered exactly that.",
  "testimonials.4.name": "Thomas B.",
  "testimonials.4.quote":
    "Very professional and pleasant. The 15-minute Classic was ideal between two appointments.",
  "testimonials.5.name": "Elena W.",
  "testimonials.5.quote":
    "Simple, friendly and surprisingly effective. I would book Wake-Up again immediately.",
  "testimonials.6.name": "Robert H.",
  "testimonials.6.quote":
    "Classic was the right choice after a long travel day. Calm, clean and very restorative.",
  "testimonials.7.name": "Amelie T.",
  "testimonials.7.quote":
    "The short activation saved my day. Easy booking, on time and very warm.",
  "master.kicker": "A word from Master Sura",
  "master.title": "Recovery can feel effortless.",
  "master.quote":
    "My goal is for hotel guests to breathe more freely, stand lighter and arrive in Hamburg with renewed energy within just a few minutes.",
  "master.name": "Master Sura · Dr. Hoffmann Massage",
  "master.alt": "Master Sura",
  "options.hotel-wakeup-5.title": "Wake-Up Massage",
  "options.hotel-wakeup-5.subtitle": "Energy in just a few minutes",
  "options.hotel-wakeup-5.priceNote": "p. p.",
  "options.hotel-wakeup-5.description":
    "Our Wake-Up massage is the fast 4-in-1 activation for your body. It promotes circulation, relieves tension, supports recovery and improves mobility. Ideal when you need fresh energy quickly.",
  "options.hotel-quick-15.title": "Classic Massage",
  "options.hotel-quick-15.subtitle": "Full-body recovery for the week",
  "options.hotel-quick-15.priceNote": "15 min",
  "options.hotel-quick-15.description":
    "Our classic massage is a targeted full-body massage designed for lasting relaxation and renewed energy. Using percussive massage techniques, tension and adhesions throughout the body are worked on intensively, circulation is stimulated, and regeneration is supported. After a short recovery phase, the body feels freer, more flexible, and full of energy again – ideal for maintaining a balanced flow of energy throughout the entire week.",
  "options.hotel-performance-60.title": "Personal Training & Mobility",
  "options.hotel-performance-60.subtitle": "Wellness for body and mind",
  "options.hotel-performance-60.priceNote": "60 min",
  "options.hotel-performance-60.description":
    "For guests who want to train, mobilise or relax with purpose. On request also available as a guided session in a gym of your choice.",
  "option.select": "Choose appointment",
  "option.selected": "Selected",
  "step.dateTime": "{title} — {em}Date & time{/em}",
  "step.details": "Your {em}details{/em}",
  "step.payment": "{em}Payment{/em}",
  "step.booking": "Your {em}booking{/em}",
  "calendar.prev": "← Back",
  "calendar.next": "Next →",
  "calendar.closedDay": "Not available",
  "calendar.closedWeekend": "Saturday and Sunday are not available",
  "slots.loading": "Loading available times…",
  "slots.none":
    "No suitable appointments are available today. Please choose a later date.",
  "slots.error.leadTime": "Please choose an appointment at least {minutes} minutes in advance.",
  "slots.error.hours": "Please choose a start time between 07:00 and 20:00, or until 22:00 on Thursdays.",
  "slots.error.generic":
    "We could not load suitable appointments. Please choose a later time.",
  "details.summary":
    "Please enter your email address and visit location so we can send your confirmation.",
  "form.firstName": "First name *",
  "form.lastName": "Last name *",
  "form.email": "Email *",
  "form.firstNamePlaceholder": "e.g. Max",
  "form.lastNamePlaceholder": "e.g. Mustermann",
  "form.emailPlaceholder": "name@example.com",
  "form.phone": "Phone number *",
  "form.visitLocation": "Where may we visit you?",
  "form.visitLocation.hotel": "In the hotel",
  "form.visitLocation.wellness": "In the wellness area",
  "form.floor": "Floor *",
  "form.room": "Room number *",
  "form.notes": "Notes (optional)",
  "form.phonePlaceholder": "+49 ...",
  "form.floorPlaceholder": "e.g. 4",
  "form.roomPlaceholder": "e.g. 412",
  "form.notesPlaceholder": "Doorbell name, special requests…",
  "payment.summary":
    "Choose whether you want to pay online or on site at the appointment.",
  "payment.onSite.title": "Pay on site",
  "payment.onSite.desc": "Cash or card in your room at the appointment.",
  "payment.online.title": "Pay online",
  "payment.online.desc": "After confirming, Stripe will redirect you to payment.",
  "summary.service": "Service",
  "summary.duration": "Duration",
  "summary.date": "Date",
  "summary.time": "Time",
  "summary.name": "Name",
  "summary.email": "Email",
  "summary.visitLocation": "Visit location",
  "summary.floor": "Floor",
  "summary.room": "Room",
  "summary.payment": "Payment",
  "summary.total": "Total",
  "summary.durationValue": "{minutes} min",
  "summary.paymentOnline": "Online",
  "summary.paymentOnSite": "On site",
  "summary.empty": "—",
  "verify.title": "Email confirmation required",
  "verify.body":
    "You can reserve the appointment now. Only after confirming your email address (link in your inbox) will the booking become binding and our team will be notified. Without confirmation, the appointment will not take place.",
  "auth.body":
    "You need an account to book. Your details will be saved when you sign in or register. After registration you can book immediately; email confirmation makes the appointment binding.",
  "auth.login": "Sign in",
  "auth.register": "Register for free",
  "submit.processing": "Booking in progress…",
  "submit.pay": "Proceed to payment",
  "submit.reserve": "Reserve appointment",
  "submit.confirm": "Book now",
  "submit.guest": "Complete booking",
  "error.pickSlot": "Please choose an appointment.",
  "error.completeName":
    "Please complete your account with first and last name first.",
  "error.firstName": "Please enter your first name.",
  "error.lastName": "Please enter your last name.",
  "error.email": "Please enter your email address.",
  "error.emailInvalid": "Please enter a valid email address.",
  "error.floor": "Please enter your floor.",
  "error.room": "Please enter your room number.",
  "error.phone":
    "Please provide a phone number so we can reach you if needed.",
  "error.loginRequired":
    "Please sign in or register to complete your booking.",
  "error.checkout": "Payment page could not be opened.",
  "error.bookingFailed": "The booking could not be created.",
  "shell.nav.home": "Home",
  "shell.nav.concept": "Concept",
  "shell.nav.license": "License model",
  "shell.nav.career": "Careers",
  "shell.nav.pricing": "Pricing",
  "shell.nav.contact": "Contact",
  "shell.nav.events": "Events",
  "shell.nav.admin": "Admin",
  "shell.nav.bookCta": "Book appointment",
  "shell.nav.shop": "Shop",
  "shell.nav.referral": "Referral",
  "shell.nav.accountMenu": "Open account menu",
  "shell.nav.myAccount": "My account",
  "shell.nav.myAppointments": "My appointments",
  "shell.nav.vouchers": "Vouchers",
  "shell.nav.referFriends": "Refer friends",
  "shell.nav.logout": "Sign out",
  "shell.nav.loginMenu": "Open login menu",
  "shell.nav.login": "Sign in",
  "shell.nav.register": "Register",
  "shell.nav.openMenu": "Open menu",
  "shell.footer.offer": "Services",
  "shell.footer.book": "Book appointment",
  "shell.footer.shop": "Vouchers",
  "shell.footer.referral": "Referral",
  "shell.footer.career": "Careers",
  "shell.footer.partner": "Become a license partner",
  "shell.footer.pricing": "Pricing",
  "shell.footer.promo": "June promotion",
  "shell.footer.account": "Account",
  "shell.footer.login": "Sign in",
  "shell.footer.register": "Register",
  "shell.footer.myAccount": "My account",
  "shell.footer.contact": "Contact",
  "shell.footer.rights": "All rights reserved",
  "shell.footer.imprint": "Legal notice",
  "shell.footer.privacy": "Privacy policy",
  "shell.auth.login.kicker": "Sign in",
  "shell.auth.login.title": "Welcome {em}back{/em}",
  "shell.auth.login.lead":
    "Sign in to book in-studio and on-site appointments or manage your existing bookings.",
  "shell.auth.login.email": "Email",
  "shell.auth.login.password": "Password",
  "shell.auth.login.submitting": "Signing in...",
  "shell.auth.login.submit": "Sign in",
  "shell.auth.login.noAccount": "No account yet?",
  "shell.auth.login.registerLink": "Register now →",
  "shell.auth.login.forgotPassword": "Forgot password?",
  "shell.auth.login.failed": "Sign-in failed.",
  "shell.auth.register.kicker": "Create account",
  "shell.auth.register.title": "New {em}account{/em}",
  "shell.auth.register.lead":
    "Register to book in-studio and on-site appointments, manage bookings and receive email reminders.",
  "shell.auth.register.firstName": "First name",
  "shell.auth.register.lastName": "Last name",
  "shell.auth.register.email": "Email",
  "shell.auth.register.phone": "Phone number (optional)",
  "shell.auth.register.phonePlaceholder": "+49 ...",
  "shell.auth.register.address": "Massage address (optional)",
  "shell.auth.register.addressPlaceholder": "Street, house number, postal code and city",
  "shell.auth.register.invoiceAddress": "Billing address (optional)",
  "shell.auth.register.invoiceCompany": "Company name (optional)",
  "shell.auth.register.invoiceStreet": "Street and house number",
  "shell.auth.register.invoicePostalCode": "Postal code",
  "shell.auth.register.invoiceCity": "City",
  "shell.auth.register.password": "Password",
  "shell.auth.register.passwordConfirm": "Confirm password",
  "shell.auth.register.privacyPrefix": "I have read the",
  "shell.auth.register.privacyLink": "privacy policy",
  "shell.auth.register.privacySuffix":
    "and agree to the processing of my data for appointment booking.",
  "shell.auth.register.agbPrefix": "I have read and accept the",
  "shell.auth.register.agbLink": "Terms and Conditions",
  "shell.auth.register.agbSuffix": "",
  "shell.auth.register.submitting": "Registering...",
  "shell.auth.register.submit": "Create account",
  "shell.auth.register.hasAccount": "Already registered?",
  "shell.auth.register.loginLink": "Sign in now →",
  "shell.auth.register.passwordMismatch": "Passwords do not match.",
  "shell.auth.register.acceptTerms": "Please accept the privacy policy.",
  "shell.auth.register.acceptAgb": "Please accept the terms and conditions.",
  "shell.auth.register.failed": "Registration failed.",
  "shell.auth.register.verifyEmail": "Please confirm your email address.",
  "shell.auth.register.verifyEmailTitle": "Confirm your email",
  "shell.auth.register.verifyEmailHint":
    "We sent you a confirmation link. Please check your inbox and click the link to activate your account.",
  "shell.auth.register.verifyEmailOk": "OK",
  "shell.auth.register.name.firstRequired": "Please enter your first name.",
  "shell.auth.register.name.firstShort": "First name must be at least 2 characters.",
  "shell.auth.register.name.firstLong": "First name must be at most 50 characters.",
  "shell.auth.register.name.lastRequired": "Please enter your last name.",
  "shell.auth.register.name.lastShort": "Last name must be at least 2 characters.",
  "shell.auth.register.name.lastLong": "Last name must be at most 50 characters.",
  "shell.auth.register.stepOf": "Step {current} of {total}",
  "shell.auth.register.stepName.title": "Name",
  "shell.auth.register.stepName.lead": "",
  "shell.auth.register.stepContact.title": "Contact",
  "shell.auth.register.stepContact.lead": "",
  "shell.auth.register.stepPassword.title": "Password",
  "shell.auth.register.stepPassword.lead": "Min. 8 characters",
  "shell.auth.register.stepTerms.title": "Agreement",
  "shell.auth.register.stepTerms.lead": "",
  "shell.auth.register.next": "Continue",
  "shell.auth.register.back": "Back",
  "shell.auth.register.emailRequired": "Please enter your email address.",
  "shell.auth.register.emailInvalid": "Please enter a valid email address.",
  "shell.auth.register.passwordShort": "Password must be at least 8 characters.",
  "success.title": "Thank {em}you!{/em}",
  "success.confirmingPayment":
    "Your payment is being confirmed — your appointment will be booked shortly.",
  "success.pendingEmail":
    "Your appointment is reserved. Please confirm your email address using the link in your inbox. Only then will the booking become binding and our team will be notified.",
  "success.pendingEmployee":
    "Your booking request has been received and is awaiting confirmation by our team. You will receive another email once the appointment is confirmed.",
  "success.confirmed": "Your booking is confirmed. A confirmation email with all details is on its way.",
  "success.failed": "The booking could not be completed.",
  "success.verifyHint":
    "Without email confirmation, the appointment will not take place. Please also check your spam folder.",
  "success.paymentPending":
    "Payment is still being confirmed. Please check your account in a few minutes or contact us.",
  "success.notFound": "Booking not found.",
  "success.service": "Service",
  "success.duration": "Duration",
  "success.durationValue": "{minutes} min",
  "success.persons": "Guests",
  "success.appointment": "Appointment",
  "success.byArrangement": "By arrangement",
  "success.name": "Name",
  "success.floor": "Floor",
  "success.room": "Room",
  "success.location": "Location",
  "success.price": "Price",
  "success.free": "Free",
  "success.net": "Net",
  "success.vat": "VAT 19%",
  "success.gross": "Gross",
  "success.status": "Status",
  "success.statusPending": "Awaiting confirmation",
  "success.statusConfirmed": "Confirmed",
  "success.payment": "Payment",
  "success.paymentPaidOnline": "Online (paid)",
  "success.paymentFreeFirst": "Free (first visit)",
  "success.paymentOnline": "Online",
  "success.paymentOnSite": "On site",
  "success.accountCta": "Go to my account",
  "success.moreOptions": "More options",
  "success.homeCta": "Back to home",
  "success.backToLeonardo": "Back to booking",
  "shell.auth.verify.kicker": "Email confirmation",
  "shell.auth.verify.title": "{em}Verification{/em}",
  "shell.auth.verify.loading": "Confirming email address...",
  "shell.auth.verify.loadingEmailChange": "Confirming new email address...",
  "shell.auth.verify.success": "Email address confirmed successfully.",
  "shell.auth.verify.successEmailChange": "New email address confirmed successfully.",
  "shell.auth.verify.successBooking":
    "Email confirmed. Your reserved appointment is now binding — our team has been notified.",
  "shell.auth.verify.incomplete": "The confirmation link is incomplete.",
  "shell.auth.verify.invalid": "The confirmation link is invalid or has expired.",
  "shell.auth.verify.backToLogin": "Back to sign in",
  "shell.auth.verify.backToLeonardo": "Back to booking",
};

export default en;
